import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialCustomersState = {
  entities: [],
  totalCount: null,
  listLoading: false,
  actionsLoading: false,
  completed: false,
  isDownLoading: false,
  exportURL: null,
  printUrl: null,
  ledgerHtml: null,
  exportStatus: null,
  ImportStatus: null,
  printStatus: null,
  customerLogsExportUrl: null,
  customerLogsExportStatus: null,
  customerNumbers: {
    customer_no: "",
    shipping_no: "",
  },
  message: {
    error: null,
    success: null,
    completed: null,
  },
  latestCustomer: null,
  licenses: {
    other: [],
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const customersSlice = createSlice({
  name: "customers",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // customers fetched from api
    customersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.licenses = { other: [] };
    },

    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },
    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },
    updateDownLoadingStatus: (state, action) => {
      state.isDownLoading = action.payload;
    },
    updateImportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ImportStatus = status;
      state.ImportUrl = url;
    },
    updatePrintLedgerStatus: (state, action) => {
      const { printStatus, printUrl, ledgerHtml } = action.payload;
      state.printStatus = printStatus;
      state.ledgerHtml = ledgerHtml;
      state.printUrl = printUrl;
      if ("FAILURE" == printStatus) {
        notification.error({ message: printStatus });
      }
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "completed":
          state.message.completed = message;
          break;
      }
    },
    numbersGenerated: (state, action) => {
      const { entity } = action.payload;
      state.customerNumbers = entity;
      state.actionsLoading = false;
    },
    removeOtherLicense: (state, action) => {
      const { index } = action.payload;
      const currentLicenses = state.licenses;
      let otherLicense = currentLicenses.other.filter((lic) => {
        return lic.index != index;
      });
      state.licenses.other = otherLicense;
    },
    fileUploaded: (state, action) => {
      const { url, licenseName, type, index } = action.payload;
      let currentLicenses = state.licenses;
      if (type === "basic") {
        currentLicenses[licenseName] = url;
      } else {
        currentLicenses.other = [...currentLicenses.other, { file: url, index: index }];
      }
      state.licenses = currentLicenses;
      state.actionsLoading = false;
    },
    customerCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(entity);
      state.totalCount = state.totalCount + 1;
      state.message.success = message;
    },
    // update customer
    customerUpdated: (state, action) => {
      const { entity, message } = action.payload;
      state.entities = state.entities.map((item) => {
        if (item.id === entity.id) {
          item = entity;
        }
        return item;
      });
      state.error = null;
      state.actionsLoading = false;
      state.message.success = message;
      state.completed = true;
      state.latestCustomer = entity;
    },
    licenseUpdated: (state, action) => {
      const { entity, message } = action.payload;
      state.entities = state.entities.map((item) => {
        if (item.id === entity.id) {
          item = entity;
        }
        return item;
      });
      state.error = null;
      state.actionsLoading = false;
      state.message.success = message;
      state.message.completed = message;
      state.completed = false;
      state.latestCustomer = entity;
    },
    customerDeleted: (state, action) => {
      const { id, message } = action.payload;
      state.entities = state.entities.filter((entity) => entity.id != id);
      state.message.success = message;
      state.message.completed = message;
      state.actionsLoading = false;
      state.error = null;
    },
    expiryEmailCustomer: (state, action) => {
      const { message } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.message.success = message;
    },
    updateCustomerLogsExportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerLogsExportStatus = status;
      state.customerLogsExportUrl = url;
    },
  },
});
